export const generateCanvasDataSourceAlias = (
  name: string,
  index: number,
): string => {
  const slug = name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 40);
  return slug || `ds_${index + 1}`;
};
